import { render, staticRenderFns } from "./board-changelog-tooltip.vue?vue&type=template&id=6a39e8ac"
import script from "./board-changelog-tooltip.vue?vue&type=script&lang=js"
export * from "./board-changelog-tooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports